<template>
    <div class="door bg_white" v-show="show">
        <div class="header">
            <button type="create" class="fr" @click="createEvent" v-if="role==='agent'">新建</button>
            <button type="back" class="fr" @click="backEvent">返回</button>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData" @deleteEvent="deleteEvent" @editEvent="editEvent"
               @openEvent="openEvent" @disableEvent="disableEvent" @ableEvent="ableEvent"></lists>
        <door-detail ref="doorDetail" @updateData="$refs.lists.updateData()"></door-detail>
    </div>
</template>

<script>
    import Lists from '@/components/Lists'
    import DoorDetail from './doorDetail'
    import {mapGetters} from "vuex";
    export default {
        name: "door",
        components: {
            Lists, DoorDetail
        },
        data() {
            return {
                show: false,
                point_id: null,
                lists: {
                    title: [{text: '柜门编号'}, {text: '柜门型号'}, {text: '板卡id'}, {text: '通道id'}, {text: '柜门状态'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '15%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '25%', textAlign: 'left'},
                ],
                httpRequestData: {
                    url: '/manage/door',
                    func: this.httpRequestHandle,
                    error: '获取柜门信息出错',
                    auto: false
                },
            }
        },
        computed: {
            ...mapGetters({
                role: 'user/role'
            }),
        },
        methods: {
            init(point_id,project_id) {
                this.show = true;
                this.point_id = point_id;
                this.$refs.lists.updateData({point_id: this.point_id});
            },
            httpRequestHandle(data) {
                let operation = this.role === 'admin' || this.role === 'partner' ? {text: '-----'} : {
                    arr: [
                        {text: '删除', style: {color: '#FF2118'}, event: 'deleteEvent'},
                        {text: '编辑', style: {color: '#1890FF'}, event: 'editEvent'},
                        {text: '强制打开', style: {color: '#1890FF'}, event: 'openEvent'},
                        {text: '禁用', style: {color: '#1890FF'}, event: 'disableEvent'},
                        {text: '启用', style: {color: '#1890FF'}, event: 'ableEvent'},
                    ]
                };
                return data.map(item =>{
                    return [
                        {text: item.no},
                        {text: this.$config.doorType.get(item.type)},
                        {text: item.cid},
                        {text: item.ch},
                        {text: this.$config.doorStatus.getBin(item.status)},
                        operation
                    ]
                });
            },
            closeEvent() {
                this.show = false;
            },
            deleteEvent(data) {
                this.$delete({
                    title: '删除柜门',
                    tooltipContent: '请输入当前柜门编号以删除当前柜门,数据将不可恢复，谨慎操作',
                    value: data.no,
                    confirm: () => {
                        this.$api.delete('/manage/door/' + data.id).then((data) => {
                            this.$alert.success({content: '删除成功'});
                            this.$refs.lists.updateData({point_id: this.point_id});
                        }).catch((error) => {
                            this.$alert.error({content: '删除失败，请重试：'+error});
                        });
                    }
                })
            },
            createEvent() {
                this.$refs.doorDetail.init('create',{point_id: this.point_id});
            },
            editEvent(data) {
                data.point_id = this.point_id;
                this.$refs.doorDetail.init('edit',data);
            },
            openEvent(data) {
                this.$api.post('/manage/open_door',{
                    id: data.id
                }).then((data) => {
                    this.$alert.success({content: '已打开'});
                }).catch((error) => {
                    this.$alert.error({content: '打开失败：'+error});
                });
            },
            disableEvent(data) {
                this.$api.put('/manage/door_status/' + data.id, {
                    status: 0,
                    point_id: this.point_id
                }).then((data) => {
                    this.$alert.success({content: '禁用成功'});
                    this.$refs.lists.updateData({point_id: this.point_id});
                }).catch((error) => {
                    this.$alert.error({content: '禁用失败：'+error});
                });
            },
            ableEvent(data) {
                this.$api.put('/manage/door_status/' + data.id, {
                    status: 1,
                    point_id: this.point_id
                }).then((data) => {
                    this.$alert.success({content: '启用成功'});
                    this.$refs.lists.updateData({point_id: this.point_id});
                }).catch((error) => {
                    this.$alert.error({content: '启用失败：'+error});
                });
            },
            backEvent() {
                this.show = false;
                this.$emit('navigation','point');
            }
        }
    }
</script>

<style scoped>
    .door{
        width: 1140px;
        padding: 0 5px;
    }
    .door>.header{
        height: 80px;
    }
    .door>.header>button{
        margin-top: 20px;
        margin-right: 15px;
    }
</style>